import { Outlet, useSearchParams } from "react-router-dom";
import { Navbar } from "./ui/components/Navbar";

import './index.css';
import { useContext } from "react";
import { useEffect } from "react";
import { LoaderOverlay } from "./ui/components/Loaders";
import { LoaderContext } from "./ui/context/loader/LoaderContext";

export const FDDApp = () => {
  const {loader:{status, message}} = useContext(LoaderContext);
  const [searchParams] = useSearchParams();
  const isEmbedded = searchParams.get('embedded') === '1';

  return (
    <>
      { status && <LoaderOverlay message={message}/> }
      { !isEmbedded && <Navbar/> }
      <main>
        <Outlet/> 
      </main>
    </>
  );
};